<template>
    <v-dialog v-model="dialogVisible" max-width="600px" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ getDialogTitle() }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <FolderForm :folder="folder" :mode="mode" :initial-title="initialTitle"
                        :parent-folder-id="parentFolderId" @save="onSave" @cancel="onCancel" @delete="onDelete" />
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed } from "@vue/composition-api";
import { useTranslations } from "@/@core/libs/i18n";
import FolderForm from "./FolderForm.vue";

export default {
    name: "FolderFormDialog",
    components: {
        FolderForm
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        folder: {
            type: Object,
            default: null
        },
        mode: {
            type: String,
            default: 'create',
            validator: value => ['create', 'edit'].includes(value)
        },
        initialTitle: {
            type: String,
            default: ''
        },
        parentFolderId: {
            type: Number,
            default: null
        }
    },
    setup(props, { emit }) {
        const { t } = useTranslations();

        // Control dialog visibility
        const dialogVisible = computed({
            get: () => props.show,
            set: (value) => {
                if (!value) {
                    emit('close');
                }
            }
        });

        const getDialogTitle = () => {
            return props.mode === 'edit' ? t('Muokkaa kansiota') : t('Uusi kansio');
        };

        const onSave = (savedFolder) => {
            emit('save', savedFolder);
        };

        const onDelete = () => {
            emit('delete');
        };

        const onCancel = () => {
            emit('cancel');
        };

        return {
            dialogVisible,
            getDialogTitle,
            onSave,
            onCancel,
            onDelete
        };
    }
};
</script>
